import { useState, useEffect } from 'react';

import {
  isLockedOut,
  setLockedOut as setLockedOutToStorage,
  getLockedOutTimestamp,
  setLockedOutTimestamp,
} from '../services/auth/auth-storage';

const useLockoutMechanism = () => {
  const computeLockoutDuration = () => {
    const timestamp = getLockedOutTimestamp();

    if (timestamp) {
      const fiveMinutesAfterLockout = new Date(timestamp);
      fiveMinutesAfterLockout.setMinutes(timestamp.getMinutes() + 5);

      return Math.abs(fiveMinutesAfterLockout - timestamp);
    }

    return null;
  };

  const [lockedOut, setLockedOut] = useState(isLockedOut());
  const [timeUntilLockoutExpiration, setTimeUntilLockoutExpiration] = useState(computeLockoutDuration());

  const lockOut = (lockedOutTimestamp) => {
    setLockedOutToStorage(true);
    setLockedOutTimestamp(lockedOutTimestamp);

    setLockedOut(true);
    setTimeUntilLockoutExpiration(computeLockoutDuration());
  };

  useEffect(() => {
    let timeout;
    let interval;

    if (lockedOut && timeUntilLockoutExpiration) {
      timeout = setTimeout(() => {
        setLockedOut(false);
        setLockedOutToStorage(false);
        setLockedOutTimestamp(null);
      }, timeUntilLockoutExpiration);

      interval = setInterval(() => {
        setTimeUntilLockoutExpiration(timestamp => timestamp - 1000);
      }, 1000);
    }

    return () => {
      if (timeout && interval) {
        clearTimeout(timeout);
        clearInterval(interval);
      }
    };
  }, [lockedOut, timeUntilLockoutExpiration]);

  return {
    lockedOut,
    timeUntilLockoutExpiration,
    lockOut,
  };
};

export default useLockoutMechanism;
